import { render, staticRenderFns } from "./PriceComponent.vue?vue&type=template&id=5102f3e4"
import script from "./PriceComponent.vue?vue&type=script&lang=js"
export * from "./PriceComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports